const MuiCardActions = {
    root: {
        padding: '24px 0 0 0',
    },
};

export default MuiCardActions;
